(function() {
  var boardLengthInput = document.getElementById('tms-board-length');
  var leftOffsetInput = document.getElementById('tms-left-offset');
  var rightOffsetInput = document.getElementById('tms-right-offset');
  var layoutTypeInput = document.getElementById('tms-layout-type');
  var holeCountInput = document.getElementById('tms-hole-count');
  var maxGapInput = document.getElementById('tms-max-gap');

  var holeCountWrap = document.getElementById('tms-hole-count-wrap');
  var maxGapWrap = document.getElementById('tms-max-gap-wrap');

  var copyPositionsBtn = document.getElementById('tms-copy-positions');
  var clearBtn = document.getElementById('tms-clear-spacing');
  var messageBox = document.getElementById('tms-spacing-message');

  var summarySpan = document.getElementById('tms-summary-span');
  var summaryHoles = document.getElementById('tms-summary-holes');
  var summarySpacing = document.getElementById('tms-summary-spacing');
  var summaryEnds = document.getElementById('tms-summary-ends');
  var positionList = document.getElementById('tms-position-list');

  if (
    !boardLengthInput ||
    !leftOffsetInput ||
    !rightOffsetInput ||
    !layoutTypeInput ||
    !holeCountInput ||
    !maxGapInput ||
    !copyPositionsBtn ||
    !clearBtn ||
    !messageBox ||
    !summarySpan ||
    !summaryHoles ||
    !summarySpacing ||
    !summaryEnds ||
    !positionList
  ) {
    return;
  }

  function formatNumber(value, digits) {
    if (!isFinite(value)) {
      return '0';
    }

    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits == null ? 2 : digits
    });
  }

  function formatMm(value, digits) {
    return formatNumber(value, digits) + ' mm';
  }

  function clearValidation() {
    var fields = [boardLengthInput, leftOffsetInput, rightOffsetInput, holeCountInput, maxGapInput];
    for (var i = 0; i < fields.length; i++) {
      fields[i].classList.remove('is-invalid');
    }
  }

  function setMessage(text, type) {
    messageBox.textContent = text || '';
    messageBox.classList.remove('is-error', 'is-success');

    if (type) {
      messageBox.classList.add(type);
    }
  }

  function setModeVisibility() {
    var byCount = layoutTypeInput.value === 'count';
    holeCountWrap.hidden = !byCount;
    maxGapWrap.hidden = byCount;
  }

  function renderEmptyPositions(label) {
    positionList.innerHTML = '';
    var div = document.createElement('div');
    div.className = 'tms-position-item';
    div.innerHTML = '<span>' + label + '</span><strong>-</strong>';
    positionList.appendChild(div);
  }

  function resetSummary() {
    summarySpan.textContent = '0 mm';
    summaryHoles.textContent = '0';
    summarySpacing.textContent = '0 mm';
    summaryEnds.textContent = '0 / 0';
    renderEmptyPositions('Enter values to calculate positions');
  }

  function getData() {
    return {
      boardLength: parseFloat(boardLengthInput.value),
      leftOffset: parseFloat(leftOffsetInput.value),
      rightOffset: parseFloat(rightOffsetInput.value),
      mode: layoutTypeInput.value,
      holeCount: parseInt(holeCountInput.value, 10),
      maxGap: parseFloat(maxGapInput.value)
    };
  }

  function calculate() {
    clearValidation();
    setModeVisibility();

    var data = getData();
    var errors = [];

    if (!isFinite(data.boardLength) || data.boardLength <= 0) {
      errors.push('Enter a valid board length greater than 0.');
      boardLengthInput.classList.add('is-invalid');
    }

    if (!isFinite(data.leftOffset) || data.leftOffset < 0) {
      errors.push('Enter a valid left edge offset.');
      leftOffsetInput.classList.add('is-invalid');
    }

    if (!isFinite(data.rightOffset) || data.rightOffset < 0) {
      errors.push('Enter a valid right edge offset.');
      rightOffsetInput.classList.add('is-invalid');
    }

    if (!errors.length && (data.leftOffset + data.rightOffset > data.boardLength)) {
      errors.push('Left and right offsets cannot be greater than the board length.');
      leftOffsetInput.classList.add('is-invalid');
      rightOffsetInput.classList.add('is-invalid');
    }

    if (data.mode === 'count') {
      if (!isFinite(data.holeCount) || data.holeCount < 1) {
        errors.push('Enter a valid number of holes.');
        holeCountInput.classList.add('is-invalid');
      }
    } else {
      if (!isFinite(data.maxGap) || data.maxGap <= 0) {
        errors.push('Enter a valid maximum allowed spacing.');
        maxGapInput.classList.add('is-invalid');
      }
    }

    if (errors.length) {
      resetSummary();
      setMessage(errors[0], 'is-error');
      return null;
    }

    var usableSpan = data.boardLength - data.leftOffset - data.rightOffset;
    var holeCount;
    var actualSpacing;

    if (data.mode === 'count') {
      holeCount = data.holeCount;

      if (holeCount === 1) {
        actualSpacing = 0;
      } else {
        actualSpacing = usableSpan / (holeCount - 1);
      }
    } else {
      if (usableSpan === 0) {
        holeCount = 2;
        actualSpacing = 0;
      } else {
        holeCount = Math.ceil(usableSpan / data.maxGap) + 1;
        if (holeCount < 2) {
          holeCount = 2;
        }
        actualSpacing = usableSpan / (holeCount - 1);
      }
    }

    var positions = [];
    for (var i = 0; i < holeCount; i++) {
      var position;

      if (holeCount === 1) {
        position = data.leftOffset;
      } else {
        position = data.leftOffset + (actualSpacing * i);
      }

      positions.push(position);
    }

    summarySpan.textContent = formatMm(usableSpan, 2);
    summaryHoles.textContent = String(holeCount);
    summarySpacing.textContent = formatMm(actualSpacing, 2);
    summaryEnds.textContent = formatMm(positions[0], 2) + ' / ' + formatMm(positions[positions.length - 1], 2);

    positionList.innerHTML = '';

    for (var j = 0; j < positions.length; j++) {
      var item = document.createElement('div');
      item.className = 'tms-position-item';
      item.innerHTML =
        '<span>Hole ' + (j + 1) + '</span>' +
        '<strong>' + formatMm(positions[j], 2) + '</strong>';
      positionList.appendChild(item);
    }

    setMessage('Spacing calculated successfully.', 'is-success');

    return {
      usableSpan: usableSpan,
      holeCount: holeCount,
      actualSpacing: actualSpacing,
      positions: positions
    };
  }

  function copyPositions() {
    var result = calculate();
    if (!result) {
      return;
    }

    var lines = [];
    lines.push('Screw and Dowel Spacing Positions');
    lines.push('');
    lines.push('Usable span: ' + formatMm(result.usableSpan, 2));
    lines.push('Actual spacing: ' + formatMm(result.actualSpacing, 2));
    lines.push('Total holes: ' + result.holeCount);
    lines.push('');

    for (var i = 0; i < result.positions.length; i++) {
      lines.push('Hole ' + (i + 1) + ': ' + formatMm(result.positions[i], 2));
    }

    var text = lines.join('\n');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() {
        setMessage('Positions copied successfully.', 'is-success');
      }).catch(function() {
        setMessage('Unable to copy positions on this device.', 'is-error');
      });
      return;
    }

    try {
      var temp = document.createElement('textarea');
      temp.value = text;
      document.body.appendChild(temp);
      temp.select();
      document.execCommand('copy');
      document.body.removeChild(temp);
      setMessage('Positions copied successfully.', 'is-success');
    } catch (error) {
      setMessage('Unable to copy positions on this device.', 'is-error');
    }
  }

  function clearCalculator() {
    boardLengthInput.value = '';
    leftOffsetInput.value = '';
    rightOffsetInput.value = '';
    layoutTypeInput.value = 'count';
    holeCountInput.value = '';
    maxGapInput.value = '';
    clearValidation();
    setModeVisibility();
    resetSummary();
    setMessage('Calculator cleared.', 'is-success');
  }

  var inputs = [boardLengthInput, leftOffsetInput, rightOffsetInput, layoutTypeInput, holeCountInput, maxGapInput];
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('input', calculate);
    inputs[i].addEventListener('change', calculate);
  }

  copyPositionsBtn.addEventListener('click', copyPositions);
  clearBtn.addEventListener('click', clearCalculator);

  setModeVisibility();
  resetSummary();
})();